module.exports = __webpack_public_path__ + "img/vi.b829f02f.png";